export default __webpack_public_path__ + "static/media/nsn.35f66063.png";